import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';

import classes from "./FlightDetailsRoundTrip.scss";
import AnimakitExpander from 'animakit-expander';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import ButtonProceedMobile from '../../UI/Button/ButtonProceedMobile/ButtonProceedMobile';
import Note from '../Tuple/TupleInner/FlightInfo/FlightNote/FlightNote';
import InfoLabel from '../Tuple/TupleInner/FlightInfo/FlightInfoLayover/FlightInfoLayover';

import FareRules from '../Tuple/TupleInner/FareInfo/FareRules/FareRules';
import FlightDetailsRoundTripTuple from './FlightDetailsRoundTripTuple/FlightDetailsRoundTripTuple';
import IntBaggage from '../Tuple/TupleInner/IntBaggage/IntBaggage';

import * as uiActions from '../../../store/actions/ui';
import * as fareRuleActions from '../../../store/actions/index';
import { closeSidebar } from '../../../store/actions/index';

const flightDetailsRoundTrip = (props) => {

  let baggage = null;
  let baggageCounter = null;

  if (props.baggageCounter > baggageCounter) {
    props.intBaggage.forEach(element => {
      if (element.id === props.departId) {
        baggage = element.baggageData;
      }
    })
  }

  let fsO = null;
  let summaryO = null;
  let aircraftNameO = null;
  let acO = null;
  let tdu = null;
  let tduR = null;

  let fsR = null;
  let summaryR = null;
  let aircraftNameR = null;
  let acR = null;

  let baggageO = null;
  let mealO = null;
  let departureTerminalO = null;
  let arrivalTerminalO = null;
  let flightNumberInitialO = null;
  let flightNumberDigitO = null;
  let airlineO = null;
  let originO = null;
  let destinationO = null;
  let dTimeO = null;
  let aTimeO = null;
  let duTimeO = null;
  let adtO = null;
  let ddtO = null;

  let baggageR = null;
  let mealR = null;
  let departureTerminalR = null;
  let arrivalTerminalR = null;
  let flightNumberInitialR = null;
  let flightNumberDigitR = null;
  let airlineR = null;
  let originR = null;
  let destinationR = null;
  let dTimeR = null;
  let aTimeR = null;
  let duTimeR = null;
  let adtR = null;
  let ddtR = null;

  // 1 Stop

  let fsOneO = '';
  let aircraftNameOneO = '';
  let acOneO = '';
  let baggageOneO = '';
  let mealOneO = '';
  let departureTerminalOneO = '';
  let arrivalTerminalOneO = '';
  let flightNumberInitialOneO = '';
  let flightNumberDigitOneO = '';
  let airlineOneO = '';
  let originOneO = '';
  let destinationOneO = '';
  let dTimeOneO = '';
  let aTimeOneO = '';
  let duTimeOneO = '';
  let adtOneO = '';
  let ddtOneO = '';
  let isTvOneO = null;

  let fsOneR = '';
  let aircraftNameOneR = '';
  let acOneR = '';
  let baggageOneR = '';
  let mealOneR = '';
  let departureTerminalOneR = '';
  let arrivalTerminalOneR = '';
  let flightNumberInitialOneR = '';
  let flightNumberDigitOneR = '';
  let airlineOneR = '';
  let originOneR = '';
  let destinationOneR = '';
  let dTimeOneR = '';
  let aTimeOneR = '';
  let duTimeOneR = '';
  let adtOneR = '';
  let ddtOneR = '';
  let isTvOneR = null;

  // 2 Stop

  let fsTwoO = '';
  let aircraftNameTwoO = '';
  let acTwoO = '';
  let baggageTwoO = '';
  let mealTwoO = '';
  let departureTerminalTwoO = '';
  let arrivalTerminalTwoO = '';
  let flightNumberInitialTwoO = '';
  let flightNumberDigitTwoO = '';
  let airlineTwoO = '';
  let originTwoO = '';
  let destinationTwoO = '';
  let dTimeTwoO = '';
  let aTimeTwoO = '';
  let duTimeTwoO = '';
  let adtTwoO = '';
  let ddtTwoO = '';

  let isTvTwoO = null;

  let fsTwoR = '';
  let aircraftNameTwoR = '';
  let acTwoR = '';
  let baggageTwoR = '';
  let mealTwoR = '';
  let departureTerminalTwoR = '';
  let arrivalTerminalTwoR = '';
  let flightNumberInitialTwoR = '';
  let flightNumberDigitTwoR = '';
  let airlineTwoR = '';
  let originTwoR = '';
  let destinationTwoR = '';
  let dTimeTwoR = '';
  let aTimeTwoR = '';
  let duTimeTwoR = '';
  let adtTwoR = '';
  let ddtTwoR = '';
  let isTvTwoR = null;

  let totalFareO = 0;
  let totalFareR = 0;

  let departFlight = null;
  let returnFlight = null;

  let lengthFS = 0;
  let lengthFSR = 0;

  if(props.requestParams.destinationCountry !== "IN" || props.requestParams.originCountry !== "IN") {
    for(let i = 0; i < props.flights.int.intRoundTripDepart.length; i++ ) {
      for(let j = 0; j < props.flights.int.intRoundTripDepart[i].length; j++) {
        if(props.flights.int.intRoundTripDepart[i][j].ID === props.departId) {
          departFlight = props.flights.int.intRoundTripDepart[i][j];
          break;
        }
      }
    }
    for(let i = 0; i < props.flights.int.intRoundTripReturn.length; i++ ) {
      for(let j = 0; j < props.flights.int.intRoundTripReturn[i].length; j++) {
        if(props.flights.int.intRoundTripReturn[i][j].ID === props.returnId) {
          returnFlight = props.flights.int.intRoundTripReturn[i][j];
          break;
        }
      }
    }
    fsO = departFlight.FS[0];
    summaryO = departFlight.FD.O;
    fsR = returnFlight.FS[0];
    summaryR = returnFlight.FD.O;
  } else {
      departFlight = props.flights.dom.roundTripOnward.filter(flight => flight.ID === props.departId);
      returnFlight = props.flights.dom.roundTripReturn.filter(flight => flight.ID === props.returnId);
      if(departFlight.length === 0) {
        fsR = returnFlight[0].OD[0].FS[0];
        summaryR = returnFlight[0].FD.O;
      } else if (returnFlight.length === 0) {
        fsO = departFlight[0].OD[0].FS[0];
        summaryO = departFlight[0].FD.O;
      } else {
        fsR = returnFlight[0].OD[0].FS[0];
        summaryR = returnFlight[0].FD.O;
        fsO = departFlight[0].OD[0].FS[0];
        summaryO = departFlight[0].FD.O;
      }
  }

  if (departFlight.length === 0) {
    console.log('No Depart Fight');
  } else {
    if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
      lengthFS = departFlight.FS.length;
      tdu = departFlight.tdu;
    } else {
      lengthFS = departFlight[0].OD[0].FS.length;
      tdu = departFlight[0].OD[0].tdu;
    }
      aircraftNameO = fsO.eq;
      acO = fsO.ac;
      baggageO = fsO.bga;
      mealO = fsO.ml;
      departureTerminalO = fsO.dt;
      arrivalTerminalO = fsO.at;
      flightNumberInitialO = fsO.ac;
      flightNumberDigitO = fsO.fl;
      airlineO = props.airlineNames[fsO.ac];
      originO = fsO.dac;
      destinationO = fsO.aac;
      dTimeO = fsO.dd;
      aTimeO = fsO.ad;
      duTimeO = fsO.du;
      adtO = fsO.adt;
      ddtO = fsO.ddt;
      isTvOneO = fsO.tv === "1";

      fsOneO = '';
      aircraftNameOneO = '';
      acOneO = '';
      baggageOneO = '';
      mealOneO = '';
      departureTerminalOneO = '';
      arrivalTerminalOneO = '';
      flightNumberInitialOneO = '';
      flightNumberDigitOneO = '';
      airlineOneO = '';
      originOneO = '';
      destinationOneO = '';
      dTimeOneO = '';
      aTimeOneO = '';
      duTimeOneO = '';
      adtOneO = '';
      ddtOneO = '';

      fsTwoO = '';
      aircraftNameTwoO = '';
      acTwoO = '';
      baggageTwoO = '';
      mealTwoO = '';
      departureTerminalTwoO = '';
      arrivalTerminalTwoO = '';
      flightNumberInitialTwoO = '';
      flightNumberDigitTwoO = '';
      airlineTwoO = '';
      originTwoO = '';
      destinationTwoO = '';
      dTimeTwoO = '';
      aTimeTwoO = '';
      duTimeTwoO = '';
      adtTwoO = '';
      ddtTwoO = '';


    if (lengthFS === 2 || lengthFS === 3) {
      if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
        fsOneO = departFlight.FS[1];
      } else {
        fsOneO = departFlight[0].OD[0].FS[1];
      }
      aircraftNameOneO = fsOneO.eq;
      acOneO = fsOneO.ac;
      baggageOneO = fsOneO.bga;
      mealOneO = fsOneO.ml;
      departureTerminalOneO = fsOneO.dt;
      arrivalTerminalOneO = fsOneO.at;
      flightNumberInitialOneO = fsOneO.ac;
      flightNumberDigitOneO = fsOneO.fl;
      airlineOneO = props.airlineNames[fsOneO.ac];
      originOneO = fsOneO.dac;
      destinationOneO = fsOneO.aac;
      dTimeOneO = fsOneO.dd;
      aTimeOneO = fsOneO.ad;
      duTimeOneO = fsOneO.du;
      adtOneO = fsOneO.adt;
      ddtOneO = fsOneO.ddt;
      isTvTwoO = fsOneO.tv === "1";
    }
    if (lengthFS === 3) {
      if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
        fsTwoO = departFlight.FS[2];
      } else {
        fsTwoO = departFlight[0].OD[0].FS[2];
      }
      aircraftNameTwoO = fsTwoO.eq;
      acTwoO = fsTwoO.ac;
      baggageTwoO = fsTwoO.bga;
      mealTwoO = fsTwoO.ml;
      departureTerminalTwoO = fsTwoO.dt;
      arrivalTerminalTwoO = fsTwoO.at;
      flightNumberInitialTwoO = fsTwoO.ac;
      flightNumberDigitTwoO = fsTwoO.fl;
      airlineTwoO = props.airlineNames[fsTwoO.ac];
      originTwoO = fsTwoO.dac;
      destinationTwoO = fsTwoO.aac;
      dTimeTwoO = fsTwoO.dd;
      aTimeTwoO = fsTwoO.ad;
      duTimeTwoO = fsTwoO.du;
      adtTwoO = fsTwoO.adt;
      ddtTwoO = fsTwoO.ddt;
    } 

    if (summaryO.revisedFareDetails) {
      totalFareO = Math.round(parseFloat(summaryO.revisedFareDetails.tf, 10));
    } 
  }

  if (returnFlight.length === 0) {
    console.log('No Return Flights');
  } else {
    if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
      lengthFSR = returnFlight.FS.length;
      tduR = returnFlight.tdu;
    } else {
      lengthFSR = returnFlight[0].OD[0].FS.length;
      tduR = returnFlight[0].OD[0].tdu;
    }
      aircraftNameR = fsR.eq;
      acR = fsR.ac;

      baggageR = fsR.bga;
      mealR = fsR.ml;
      departureTerminalR = fsR.dt;
      arrivalTerminalR = fsR.at;
      flightNumberInitialR = fsR.ac;
      flightNumberDigitR = fsR.fl;
      airlineR = props.airlineNames[fsR.ac];
      originR = fsR.dac;
      destinationR = fsR.aac;
      dTimeR = fsR.dd;
      aTimeR = fsR.ad;
      duTimeR = fsR.du;
      adtR = fsR.adt;
      ddtR = fsR.ddt;
      isTvOneR = fsR.tv === "1";
      
      fsOneR = '';
      aircraftNameOneR = '';
      acOneR = '';
      baggageOneR = '';
      mealOneR = '';
      departureTerminalOneR = '';
      arrivalTerminalOneR = '';
      flightNumberInitialOneR = '';
      flightNumberDigitOneR = '';
      airlineOneR = '';
      originOneR = '';
      destinationOneR = '';
      dTimeOneR = '';
      aTimeOneR = '';
      duTimeOneR = '';
      adtOneR = '';
      ddtOneR = '';

      fsTwoR = '';
      aircraftNameTwoR = '';
      acTwoR = '';
      baggageTwoR = '';
      mealTwoR = '';
      departureTerminalTwoR = '';
      arrivalTerminalTwoR = '';
      flightNumberInitialTwoR = '';
      flightNumberDigitTwoR = '';
      airlineTwoR = '';
      originTwoR = '';
      destinationTwoR = '';
      dTimeTwoR = '';
      aTimeTwoR = '';
      duTimeTwoR = '';
      adtTwoR = '';
      ddtTwoR = '';

    if (lengthFSR === 2 || lengthFSR === 3) {
      if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
        fsOneR = returnFlight.FS[1];
      } else {
        fsOneR = returnFlight[0].OD[0].FS[1];
      }
      aircraftNameOneR = fsOneR.eq;
      acOneR = fsOneR.ac;
      baggageOneR = fsOneR.bga;
      mealOneR = fsOneR.ml;
      departureTerminalOneR = fsOneR.dt;
      arrivalTerminalOneR = fsOneR.at;
      flightNumberInitialOneR = fsOneR.ac;
      flightNumberDigitOneR = fsOneR.fl;
      airlineOneR = props.airlineNames[fsOneR.ac];
      originOneR = fsOneR.dac;
      destinationOneR = fsOneR.aac;
      dTimeOneR = fsOneR.dd;
      aTimeOneR = fsOneR.ad;
      duTimeOneR = fsOneR.du;
      adtOneR = fsOneR.adt;
      ddtOneR = fsOneR.ddt;
      isTvTwoR = fsOneR.tv === "1";
    } 
    if (lengthFSR === 3) {
      if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
        fsTwoR = returnFlight.FS[2];
      } else {
        fsTwoR = returnFlight[0].OD[0].FS[2];
      }
      aircraftNameTwoR = fsTwoR.eq;
      acTwoR = fsTwoR.ac;
      baggageTwoR = fsTwoR.bga;
      mealTwoR = fsTwoR.ml;
      departureTerminalTwoR = fsTwoR.dt;
      arrivalTerminalTwoR = fsTwoR.at;
      flightNumberInitialTwoR = fsTwoR.ac;
      flightNumberDigitTwoR = fsTwoR.fl;
      airlineTwoR = props.airlineNames[fsTwoR.ac];
      originTwoR = fsTwoR.dac;
      destinationTwoR = fsTwoR.aac;
      dTimeTwoR = fsTwoR.dd;
      aTimeTwoR = fsTwoR.ad;
      duTimeTwoR = fsTwoR.du;
      adtTwoR = fsTwoR.adt;
      ddtTwoR = fsTwoR.ddt;
    } 

    if (summaryR.revisedFareDetails) {
      totalFareR = Math.round(parseFloat(summaryR.revisedFareDetails.tf, 10));
    }
  }

  const cityName = props.cityName;
  const originCity = cityName[props.flightCode.substring(0, 3)];
  const destinationCity = cityName[props.flightCode.substring(3, 6)];

  if(props.requestParams.destinationCountry !== 'IN' || props.requestParams.originCountry !== 'IN') {
    totalFareR = 0;
  }

  const totalFare = totalFareO + totalFareR;

  let departJSXNS = null;
  let departJSXOS = null;
  let departJSXTS = null;

  if(props.isDepartFlight) {
    departJSXNS = (
      <FlightDetailsRoundTripTuple
        ac={acO}
        airline={airlineO} 
        flightNumberInitial={flightNumberInitialO}
        flightNumberDigit={flightNumberDigitO}
        aircraftName={aircraftNameO}
        dTime={dTimeO}
        duTime={duTimeO.substring(0, 2) + 'h ' + duTimeO.substring(2, 4) + 'm'}
        aTime={aTimeO}
        originCity={originCity}
        destinationCity={destinationCity}
        origin={originO}
        destination={destinationO}
        departureTerminal={departureTerminalO}
        arrivalTerminal={arrivalTerminalO}
        adt={adtO}
        ddt={ddtO}
        baggage={baggageO}
        meal={mealO}
        />
    );

    departJSXOS = (
      <React.Fragment>
        <FlightDetailsRoundTripTuple
          ac={acO}
          airline={airlineO} 
          flightNumberInitial={flightNumberInitialO}
          flightNumberDigit={flightNumberDigitO}
          aircraftName={aircraftNameO}
          dTime={dTimeO}
          duTime={props.rtDepart ? duTimeO.substring(0, 2) + 'h ' + duTimeO.substring(2, 4) + 'm' : tdu.substring(0, 2) + 'h ' + tdu.substring(3, 5) + 'm'}
          aTime={props.rtDepart ? aTimeO : aTimeOneO}
          originCity={originCity}
          via={!props.rtDepart ? <span>via <span className={`u-fontSize13 u-fontWeightMedium u-textColorNormal`}>{props.cityNames[destinationO]}</span></span> : null}
          destinationCity={props.rtDepart ? props.cityNames[destinationO] : destinationCity}
          origin={originO}
          destination={props.rtDepart ? destinationO : destinationOneO}
          departureTerminal={departureTerminalO}
          adt={props.rtDepart ? adtO : adtOneO}
          ddt={ddtO}
          arrivalTerminal={props.rtDepart ? arrivalTerminalO : arrivalTerminalOneO}
          baggage={baggageO}
          meal={mealO}
          />
          <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtDepart()}>
            { props.rtDepart ? <p>Layover in {props.cityNames[destinationO]}</p> : <p>View more details <FontAwesomeIcon icon="caret-down" color="#666" size="1x" className={`u-textColorPrimary`} /></p> }
          </button>
          <AnimakitExpander
              expanded={props.rtDepart}
              align="bottom">
              <React.Fragment>
                {isTvOneO ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationO]} /> : null}
                <FlightDetailsRoundTripTuple
                  ac={acOneO}
                  airline={airlineOneO} 
                  flightNumberInitial={flightNumberInitialOneO}
                  flightNumberDigit={flightNumberDigitOneO}
                  aircraftName={aircraftNameOneO}
                  dTime={dTimeOneO}
                  duTime={duTimeOneO.substring(0, 2) + 'h ' + duTimeOneO.substring(2, 4) + 'm'}
                  aTime={aTimeOneO}
                  originCity={props.cityNames[destinationO]}
                  destinationCity={destinationCity}
                  origin={originOneO}
                  destination={destinationOneO}
                  adt={adtOneO}
                  ddt={ddtOneO}
                  departureTerminal={departureTerminalOneO}
                  arrivalTerminal={arrivalTerminalOneO}
                  baggage={baggageOneO}
                  meal={mealOneO}
                  />
                </React.Fragment>              
          </AnimakitExpander>
        </React.Fragment>
   );
   departJSXTS = (
    <React.Fragment>
      <FlightDetailsRoundTripTuple
          ac={acO}
          airline={airlineO} 
          flightNumberInitial={flightNumberInitialO}
          flightNumberDigit={flightNumberDigitO}
          aircraftName={aircraftNameO}
          dTime={dTimeO}
          duTime={props.rtReturn ? duTimeO.substring(0, 2) + 'h ' + duTimeO.substring(2, 4) + 'm' : tdu.substring(0, 2) + 'h ' + tdu.substring(3, 5) + 'm'}
          aTime={props.rtDepart ? aTimeO : aTimeOneO}
          originCity={originCity}
          via={!props.rtDepart ? <span>via <span className={`u-fontSize13 u-fontWeightMedium u-textColorNormal`}>{props.cityNames[destinationO]}</span></span> : null}
          destinationCity={props.rtDepart ? props.cityNames[destinationO] : destinationCity}
          origin={originO}
          adt={props.rtDepart ? adtO : adtTwoO}
          ddt={ddtO}
          destination={props.rtDepart ? destinationO : destinationTwoO}
          departureTerminal={departureTerminalO}
          arrivalTerminal={props.rtDepart ? arrivalTerminalO : arrivalTerminalTwoO}
          baggage={baggageO}
          meal={mealO}
          />
        <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtDepart()}>
          { props.rtDepart ? <p>Layover in {props.cityNames[destinationO]}</p> : <p>View more details <FontAwesomeIcon icon="caret-down" color="#666" size="1x" className={`u-textColorPrimary`} /></p> }
        </button>
        <AnimakitExpander
            expanded={props.rtDepart}
            align="bottom">
            <React.Fragment>
              {isTvOneO ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationO]} /> : null}
              <FlightDetailsRoundTripTuple
                ac={acOneO}
                airline={airlineOneO} 
                flightNumberInitial={flightNumberInitialOneO}
                flightNumberDigit={flightNumberDigitOneO}
                aircraftName={aircraftNameOneO}
                dTime={dTimeOneO}
                duTime={duTimeOneO.substring(0, 2) + 'h ' + duTimeOneO.substring(2, 4) + 'm'}
                aTime={aTimeOneO}
                adt={adtOneO}
                ddt={ddtOneO}
                originCity={props.cityNames[destinationO]}
                destinationCity={props.cityNames[destinationOneO]}
                origin={originOneO}
                destination={destinationOneO}
                departureTerminal={departureTerminalOneO}
                arrivalTerminal={arrivalTerminalOneO}
                baggage={baggageOneO}
                meal={mealOneO}
                />
              <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtDepart()}>
                <p>Layover in {props.cityNames[destinationOneO]}</p>
              </button>
              {isTvTwoO ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationOneO]} /> : null}
              <FlightDetailsRoundTripTuple
                ac={acTwoO}
                airline={airlineTwoO} 
                flightNumberInitial={flightNumberInitialTwoO}
                flightNumberDigit={flightNumberDigitTwoO}
                aircraftName={aircraftNameTwoO}
                dTime={dTimeTwoO}
                duTime={duTimeTwoO.substring(0, 2) + 'h ' + duTimeTwoO.substring(2, 4) + 'm'}
                aTime={aTimeTwoO}
                originCity={props.cityNames[destinationOneO]}
                destinationCity={destinationCity}
                origin={originTwoO}
                adt={adtTwoO}
                ddt={ddtTwoO}
                destination={destinationTwoO}
                departureTerminal={departureTerminalTwoO}
                arrivalTerminal={arrivalTerminalTwoO}
                baggage={baggageTwoO}
                meal={mealTwoO}
                />
              </React.Fragment>
        </AnimakitExpander>
      </React.Fragment>
    );
  }

  let returnJSXNS = null;
  let returnJSXOS = null;
  let returnJSXTS = null;

  if(props.isReturnFlight) {
    returnJSXNS = (
      <FlightDetailsRoundTripTuple
        ac={acR}
        airline={airlineR} 
        flightNumberInitial={flightNumberInitialR}
        flightNumberDigit={flightNumberDigitR}
        aircraftName={aircraftNameR}
        dTime={dTimeR}
        duTime={duTimeR.substring(0, 2) + 'h ' + duTimeR.substring(2, 4) + 'm'}
        aTime={aTimeR}
        originCity={destinationCity}
        destinationCity={originCity}
        origin={originR}
        adt={adtR}
        ddt={ddtR}
        destination={destinationR}
        departureTerminal={departureTerminalR}
        arrivalTerminal={arrivalTerminalR}
        baggage={baggageR}
        meal={mealR}
        />
    );
  
    returnJSXOS = (
      <React.Fragment>
        <FlightDetailsRoundTripTuple
          ac={acR}
          airline={airlineR} 
          flightNumberInitial={flightNumberInitialR}
          flightNumberDigit={flightNumberDigitR}
          aircraftName={aircraftNameR}
          dTime={dTimeR}
          duTime={props.rtReturn ? duTimeR.substring(0, 2) + 'h ' + duTimeR.substring(2, 4) + 'm' : tduR.substring(0, 2) + 'h ' + tduR.substring(3, 5) + 'm'}
          aTime={props.rtReturn ? aTimeR : aTimeOneR}
          originCity={destinationCity}
          via={!props.rtReturn ? <span>via <span className={`u-fontSize13 u-fontWeightMedium u-textColorNormal`}>{props.cityNames[destinationR]}</span></span> : null}
          destinationCity={props.rtReturn ? props.cityNames[destinationR] : originCity}
          origin={originR}
          destination={props.rtReturn ? destinationR : destinationOneR}
          departureTerminal={departureTerminalR}
          arrivalTerminal={props.rtReturn ? arrivalTerminalR : arrivalTerminalOneR}
          baggage={baggageOneR}
          adt={props.rtReturn ? adtR : adtOneR}
          ddt={ddtR}
          meal={mealR}
          />
        <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtReturn()}>
          { props.rtReturn ? <p>Layover in {props.cityNames[destinationR]}</p> : <p>View more details <FontAwesomeIcon icon="caret-down" color="#666" size="1x" className={`u-textColorPrimary`} /></p> }
        </button>
        <AnimakitExpander
            expanded={props.rtReturn}
            align="bottom">
            <React.Fragment>
              {isTvOneR ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationR]} /> : null}
              <FlightDetailsRoundTripTuple
                ac={acOneR}
                airline={airlineOneR} 
                flightNumberInitial={flightNumberInitialOneR}
                flightNumberDigit={flightNumberDigitOneR}
                aircraftName={aircraftNameOneR}
                dTime={dTimeOneR}
                duTime={duTimeOneR.substring(0, 2) + 'h ' + duTimeOneR.substring(2, 4) + 'm'}
                aTime={aTimeOneR}
                adt={adtOneR}
                ddt={ddtOneR}
                originCity={props.cityNames[destinationR]}
                destinationCity={originCity}
                origin={originOneR}
                destination={destinationOneR}
                departureTerminal={departureTerminalOneR}
                arrivalTerminal={arrivalTerminalOneR}
                baggage={baggageOneR}
                meal={mealOneR} />
            </React.Fragment> 
        </AnimakitExpander>
      </React.Fragment>
    );

    returnJSXTS = (
      <React.Fragment>
        <FlightDetailsRoundTripTuple
          ac={acR}
          airline={airlineR} 
          flightNumberInitial={flightNumberInitialR}
          flightNumberDigit={flightNumberDigitR}
          aircraftName={aircraftNameR}
          dTime={dTimeR}
          duTime={props.rtReturn ? duTimeR.substring(0, 2) + 'h ' + duTimeR.substring(2, 4) + 'm' : tduR.substring(0, 2) + 'h ' + tduR.substring(3, 5) + 'm'}
          aTime={props.rtReturn ? aTimeR : aTimeTwoR}
          originCity={destinationCity}
          via={!props.rtReturn ? <span>via <span className={`u-fontSize13 u-fontWeightMedium u-textColorNormal`}>{props.cityNames[destinationR]}</span></span> : null}
          destinationCity={props.rtReturn ? props.cityNames[destinationR] : originCity}
          origin={originR}
          adt={props.rtReturn ? adtR : adtTwoR}
          ddt={ddtR}
          destination={props.rtReturn ? destinationR : destinationTwoR}
          departureTerminal={departureTerminalR}
          arrivalTerminal={props.rtReturn ? arrivalTerminalR : arrivalTerminalTwoR}
          baggage={baggageR}
          meal={mealR}
          />
          <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtReturn()}>
            { props.rtReturn ? <p>Layover in {props.cityNames[destinationR]}</p> : <p>View more details <FontAwesomeIcon icon="caret-down" color="#666" size="1x" className={`u-textColorPrimary`} /></p> }
          </button>
          <AnimakitExpander
              expanded={props.rtReturn}
              align="bottom">
              <React.Fragment>
                {isTvOneR ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationR]} /> : null}
                <FlightDetailsRoundTripTuple
                  ac={acOneR}
                  airline={airlineOneR} 
                  flightNumberInitial={flightNumberInitialOneR}
                  flightNumberDigit={flightNumberDigitOneR}
                  aircraftName={aircraftNameOneR}
                  dTime={dTimeOneR}
                  duTime={duTimeOneR.substring(0, 2) + 'h ' + duTimeOneR.substring(2, 4) + 'm'}
                  aTime={aTimeOneR}
                  originCity={props.cityNames[destinationR]}
                  destinationCity={props.cityNames[destinationOneR]}
                  origin={originOneR}
                  adt={adtOneR}
                  ddt={ddtOneR}
                  destination={destinationOneR}
                  departureTerminal={departureTerminalOneR}
                  arrivalTerminal={arrivalTerminalOneR}
                  baggage={baggageOneR}
                  meal={mealOneR} />
                <button className={`${classes.ViewMoreButton} u-height30 u-textColorPrimary u-cursorPointer u-textAlignCenter u-borderRadius4 u-border0 u-outline0 u-width100Percent`} onClick={() => props.onToggleRtReturn()}>
                  <p>Layover in {props.cityNames[destinationOneR]}</p>
                </button>
                {isTvTwoR ? <InfoLabel type="transitVisa" flightType="R" originCity={props.cityNames[destinationOneR]} /> : null}
                <FlightDetailsRoundTripTuple
                  ac={acTwoR}
                  airline={airlineTwoR} 
                  flightNumberInitial={flightNumberInitialTwoR}
                  flightNumberDigit={flightNumberDigitTwoR}
                  aircraftName={aircraftNameTwoR}
                  dTime={dTimeTwoR}
                  adt={adtTwoR}
                  ddt={ddtTwoR}
                  duTime={duTimeTwoR.substring(0, 2) + 'h ' + duTimeTwoR.substring(2, 4) + 'm'}
                  aTime={aTimeTwoR}
                  originCity={props.cityNames[destinationOneR]}
                  destinationCity={originCity}
                  origin={originTwoR}
                  destination={destinationTwoR}
                  departureTerminal={departureTerminalTwoR}
                  arrivalTerminal={arrivalTerminalTwoR}
                  baggage={baggageTwoR}
                  meal={mealTwoR} />
              </React.Fragment>
          </AnimakitExpander>
        </React.Fragment>
    );
  }

  let departInnerView = null;
  let returnInnerView = null;

  if (props.isIntFlight) {
    if (props.detailsView === 'details') {
      if(lengthFS === 1) {
        departInnerView =  departJSXNS;
      } else if (lengthFS === 2) {
        departInnerView =  departJSXOS;
      } else if (lengthFS === 3) {
        departInnerView =  departJSXTS;
      }
      if(lengthFSR === 1) {
        returnInnerView = returnJSXNS;
      } else if(lengthFSR === 2) {
        returnInnerView = returnJSXOS;
      } else if(lengthFSR === 3) {
        returnInnerView = returnJSXTS;
      }
    } else if (props.detailsView === 'rules') {
      departInnerView = props.fareRulesSuccess ? <FareRules isIntFlight isIntRoundTrip rules={props.fareRules[0].rules}/> : null;
    } else if (props.detailsView === 'baggage') {
      departInnerView = <IntBaggage isIntRoundTrip={true} baggageData={baggage} />;
    }
  } else {
    if(lengthFS === 1) {
      departInnerView =  departJSXNS;
    } else if (lengthFS === 2) {
      departInnerView =  departJSXOS;
    } else if (lengthFS === 3) {
      departInnerView =  departJSXTS;
    }

    if(lengthFSR === 1) {
      returnInnerView = returnJSXNS;
    } else if (lengthFSR === 2) {
      returnInnerView = returnJSXOS;
    } else if(lengthFSR === 3) {
      returnInnerView = returnJSXTS;
    }
  }

  return (
    <div style={{position: props.requestParams.destinationCountry !== "IN" || props.requestParams.originCountry !== "IN"  ? window.innerWidth < 600 ? 'fixed' : 'fixed' : 'fixed'}} className={[classes.BookingSummaryContainer, props.isDepartFlight && props.isReturnFlight ? classes.BookingSummaryContainerFull : null].join(' ')}>
      {
        props.isRoundTripFareRules ? 
          <FareRules rules={props.selectedFareRule} type="domRT" />
           : 
        <React.Fragment>
        <div style={{ flex: props.rtReturn ? '0' : '1' }}>
            {
              props.isIntFlight ? 
              <React.Fragment>
                <div className={`u-lineHeight45 pt-0 pb-0 u-height45 u-flex justify-content-between align-items-center u-boxShadowThin`} onMouseEnter={() => props.onCloseRtReturn()}>
                  <div className={`f-1 u-textAlignCenter u-cursorPointer`}><span className={`${[classes.Item, props.detailsView === 'details' ? classes.ItemActive : null].join(' ')} u-block mx-auto u-width85Percent`} onClick={() => {props.onToggleDetailsView('details')}}>Flight Details</span></div>
                  <div className={`f-1 u-textAlignCenter u-cursorPointer`}><span className={`${[classes.Item, props.detailsView === 'rules' ? classes.ItemActive : null].join(' ')} u-block mx-auto u-width85Percent`} onClick={() => {
                      props.onToggleDetailsView('rules');
                      const xmlKey = departFlight.xmlKey;
                      const searchId = props.searchId;
                      const flightId = departFlight.ID;
                      const fareRules = props.fareRules;
                      let match = false;
                      fareRules.forEach((element) => {
                        if (element.id === departFlight.ID) match = true;
                      })
                      if (!match) {
                        const fareRuleParams = {
                          sc: xmlKey,
                          flightIdCSV: flightId,
                          searchId: searchId
                        }
                        props.onGetIntFareRules(fareRuleParams, flightId);
                      }
                  }}>Fare Rules</span></div>
                  <div className={`f-1 u-textAlignCenter u-cursorPointer`}><span className={`${[classes.Item, props.detailsView === 'baggage' ? classes.ItemActive : null].join(' ')} u-block mx-auto u-width85Percent`} onClick={() => {
                    props.onToggleDetailsView('baggage');
                    const intBaggage = props.intBaggage;
                    let baggageMatch = false;
                    intBaggage.forEach(element => {
                      if (element.id === departFlight.ID) {
                        baggageMatch = true;
                        baggage = element.baggageData;
                      }
                    })
                    if (!baggageMatch) {
                      const baggageParams = {
                        searchId: props.searchId,
                        flightIdCSV: departFlight.ID,
                        sc: departFlight.xmlKey
                      }
                      baggageCounter = props.baggageCounter;
                      console.log(props.flightId);
                      props.onGetBaggageInfo(baggageParams, departFlight.ID);
                    }
                  }}>Baggage</span></div>
                </div>
                {
                  props.detailsView === 'baggage' || props.detailsView === 'rules' ? null : <div className={`u-lineHeight45 pt-0 pb-0 pl-5 pr-5 u-height45 u-flex justify-content-between align-items-center u-boxShadowThin`} onMouseEnter={() => props.onCloseRtReturn()}>
                    <HeadingH2 size={16} color="Dark" weight="Medium">Departure</HeadingH2>
                  </div>
                }
              </React.Fragment> : 
              <div className={`u-lineHeight45 pt-0 pb-0 pl-5 pr-5 u-height45 u-flex justify-content-between align-items-center u-boxShadowThin`} onMouseEnter={() => props.onCloseRtReturn()}>
                <HeadingH2 size={16} color="Dark" weight="Medium">Departure</HeadingH2>
                <div className={classes.CloseImage} onClick={() => props.onToggleMobileFlightDetail()}>
                  <FontAwesomeIcon icon="times" color="#666" size="lg" />
                </div>
              <span className={`u-textColorPrimary u-textUppercase u-fontSize11 u-fontWeightMedium u-cursorPointer`} onClick={() => {
                  props.onToggleRoundTripFareRules();
                  const fareRules = props.fareRules;
                  let match = false;
                  fareRules.forEach((element) => { if (element.id === departFlight[0].ID) match = true; })
                  if(!match) {
                      const fareRuleParams =  {
                      flightIdCSV: departFlight[0].ID,
                      supplierCode: departFlight[0].supplierCode,
                      searchId: props.searchId,
                      fareBasisCode: fsO.fbc,
                      AirlineCode: acO,
                      cabin: fsO.classtype
                    }
                    props.onGetFareRules(fareRuleParams, departFlight[0].ID);
                  } else props.onSetSelectedFareRule(departFlight[0].ID);
                }}>Fare Rules</span>
            </div>
            }
            {
              props.isDepartFlight ? 
              <div className={classes.Inner} style={{ display: props.rtReturn ? 'none' : 'block'}}>
                {departInnerView}
              </div> : null
            }
          </div>
          <div style={{ flex: props.rtDepart ? '0' : '1' }}>
            {
              props.isIntFlight ? props.detailsView === 'baggage' || props.detailsView === 'rules' ? null :
              <div className={`u-lineHeight45 pt-0 pb-0 pl-5 pr-5 u-height45 u-flex justify-content-between align-items-center u-boxShadowThin`} onMouseEnter={() => props.onCloseRtDepart()}>
                <HeadingH2 size={16} color="Dark" weight="Medium">Return</HeadingH2>
              </div> :
              <div className={`u-lineHeight45 pt-0 pb-0 pl-5 pr-5 u-height45 u-flex justify-content-between align-items-center u-boxShadowThin`} onMouseEnter={() => props.onCloseRtDepart()}>
                <HeadingH2 size={16} color="Dark" weight="Medium">Return</HeadingH2>
                <span className={`u-textColorPrimary u-textUppercase u-fontSize11 u-fontWeightMedium u-cursorPointer`} onClick={() => {
                    props.onToggleRoundTripFareRules();
                    const fareRules = props.fareRules;
                    let match = false;
                    fareRules.forEach((element) => { if (element.id === returnFlight[0].ID) match = true; })
                    if(!match) {
                      const fareRuleParams =  {
                        flightIdCSV: returnFlight[0].ID,
                        supplierCode: returnFlight[0].supplierCode,
                        searchId: props.searchId,
                        fareBasisCode: fsR.fbc,
                        AirlineCode: acR,
                        cabin: fsR.classtype
                      }
                      props.onGetFareRules(fareRuleParams, returnFlight[0].ID);
                    } else props.onSetSelectedFareRule(returnFlight[0].ID);
                  }}>Fare Rules</span>
              </div>
            }
            {
              props.isReturnFlight ? 
              <div className={classes.Inner} style={{ display: props.rtDepart ? 'none' : 'block' }}>
                {returnInnerView}
              </div> : null
            }
          </div>
          {props.isIntFlight ? (
            <div className="pl-5 pr-5 mb-3 mt-auto u-flexNone">
              <Note>Passenger of all Nationalities are advised to confirm with respective embassies for all visa requirements.This communication is for informational &amp; general purposes only &amp; Yatra assumes no responsibility,legal or otherwise,of its applicability &amp; accuracy.</Note>
            </div>
          ) : null}
          <div className={`${classes.ContainerFinal} u-flex justify-content-between align-items-center`}>
            <div>
              <HeadingH3 size={16} weight="Medium" color="White">You Pay &#8377; {totalFare.toLocaleString()}</HeadingH3>
            </div>
            <ButtonProceedMobile onClick={(e) => props.proceedToBook(e)} disabled={!props.isDepartFlight || !props.isReturnFlight}>CONTINUE</ButtonProceedMobile>
          </div>
      </React.Fragment>
      }
    </div>
  );
};

const mapStateToProps = state => {
  return {
    requestParams: state.flights.requestParams,
    flights: state.flights,
    departFlight: state.flights.dom.roundTripFlights.roundTripOnward.filter(flight => flight.ID === state.roundTripSummary.departId),
    returnFlight: state.flights.dom.roundTripFlights.roundTripReturn.filter(flight => flight.ID === state.roundTripSummary.returnId),
    departId: state.roundTripSummary.departId,
    returnId: state.roundTripSummary.returnId,
    airlineNames: state.flights.airlineNames,
    cityName: state.flights.cityName,
    flightCode: state.flights.flightCode,
    rtDepart: state.ui.rtDepart,
    rtReturn: state.ui.rtReturn,
    cityNames: state.flights.cityNames,
    isDepartFlight: state.roundTripSummary.isDepartFlight,
    isReturnFlight: state.roundTripSummary.isReturnFlight,
    isRoundTripFareRules: state.ui.roundTripFareRules,
    searchId: state.flights.searchId,
    fareRules: state.fareRules.fareRules,
    rulesCounter: state.fareRules.counter,
    selectedFareRule: state.fareRules.selectedFareRule,
    isIntFlight: state.flights.requestParams.originCountry !== 'IN' || state.flights.requestParams.destinationCountry !== 'IN',
    detailsView: state.ui.detailsView,
    fareRulesSuccess: state.fareRules.success,
    intBaggage: state.fareRules.intBaggage,
    baggageCounter: state.fareRules.baggageCounter,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggleRtDepart: () => dispatch(uiActions.toggleRtDepart()),
    onToggleRtReturn: () => dispatch(uiActions.toggleRtReturn()),
    onCloseRtDepart: () => dispatch(uiActions.closeRtDepart()),
    onCloseRtReturn: () => dispatch(uiActions.closeRtReturn()),
    onToggleMobileFlightDetail: () => dispatch(uiActions.toggleMobileFlightDetail()),
    onToggleRoundTripFareRules: () => dispatch(uiActions.toggleRoundTripFareRules()),
    onGetFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getFareRules(fareRuleParams, flightId)),
    onSetSelectedFareRule: (flightId) => dispatch(fareRuleActions.setSelectedFareRule(flightId)),
    onGetIntFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getIntFareRules(fareRuleParams, flightId)),
    onCloseSidebar: () => dispatch(closeSidebar()),
    onGetBaggageInfo: (baggageParams, flightId) => dispatch(fareRuleActions.getBaggageInfo(baggageParams, flightId)),
    onToggleDetailsView: (view) => dispatch(uiActions.toggleDetailsView(view))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(flightDetailsRoundTrip);



// WEBPACK FOOTER //
// ./src/components/Flight/FlightDetailsRoundTrip/FlightDetailsRoundTrip.js